export const merohaTheme = Object.freeze({
  primary: '#463129',
  secondPrimary: '#463129',
  secondary: '#C9A98F',
  background: '#F7F0E8',
  surface: '#FFFCF8',
  textPrimary: '#2E211C',
  textSecondary: '#67564E',
  divider: '#DDCEC1',
  disabled: '#B9ADA5',
});

export const merohaThemeVariables = {
  '--primary-theme-color': merohaTheme.primary,
  '--second-primary-theme-color': merohaTheme.secondPrimary,
  '--secondary-theme-color': merohaTheme.secondary,
  '--primary-theme-light-color': '#E9DFD7',
  '--primary-bg-color': merohaTheme.background,
  '--secondary-bg-color': merohaTheme.surface,
  '--tertiary-bg-color': '#EFE3D8',
  '--quaternary-bg-color': '#E3CDBB',
  '--primary-text-color': merohaTheme.textPrimary,
  '--secondary-text-color': '#FFFFFF',
  '--tertiary-text-color': merohaTheme.textSecondary,
  '--border-color': '#B9A79B',
  '--secondary-border-color': '#E8DDD4',
  '--divider-color': merohaTheme.divider,
  '--disabled-bg-color': merohaTheme.disabled,
  '--disabled-bg-light-color': '#ECE5DF',
  '--splash-text-color': merohaTheme.primary,
};
